import React from "react";
import PropTypes from "prop-types";

import StandardFactsAndBullets from "./StandardFactsAndBullets";
import CardWallFactsAndBullets from "./CardWallFactsAndBullets";
import ComponentMissing from "../../Debug/ComponentMissing";

const FactsAndBulletsSwitcher = ({
  layout,
  header,
  headerType,
  headerDisplayStyle,
  headerLink,
  headerLinkType,
  secondaryLink,
  secondaryLinkType,
  subline,
  teaser,
  facts,
  columnsPerRow,
  cols,
  alignment,
  animation,
}) => {
  const properties = {
    header,
    headerType,
    headerDisplayStyle,
    headerLink,
    headerLinkType,
    secondaryLink,
    secondaryLinkType,
    subline,
    teaser,
    facts,
    columnsPerRow,
    cols,
    alignment,
    animation,
  };

  function switchFactsAndBullets() {
    switch (layout) {
      case "standard":
        return <StandardFactsAndBullets properties={properties} />;
      case "card-wall":
        return <CardWallFactsAndBullets properties={properties} />;
      default:
        return <ComponentMissing type="FactsAndBullets" subType={layout} />;
    }
  }

  return switchFactsAndBullets();
};

FactsAndBulletsSwitcher.propTypes = {
  layout: PropTypes.string,
  header: PropTypes.string,
  headerType: PropTypes.string,
  headerDisplayStyle: PropTypes.string,
  headerLink: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.string]),
  headerLinkType: PropTypes.string,
  secondaryLink: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.string]),
  secondaryLinkType: PropTypes.string,
  subline: PropTypes.string,
  teaser: PropTypes.string,
  facts: PropTypes.oneOfType([PropTypes.instanceOf(Array), PropTypes.string]),
  columnsPerRow: PropTypes.instanceOf(Object),
  cols: PropTypes.string,
  alignment: PropTypes.string,
  animation: PropTypes.instanceOf(Object),
};

export default FactsAndBulletsSwitcher;
